import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    fromAmount: Yup.number(),
    toAmount: Yup.number()
      .test(
        "toAmount",
        "US.COLLECTION.VALIDATIONS:REQUIRED.TO_AMOUNT_CANNOT_BE_LESSER_THAN_FROM_AMOUNT",
        function (val: any) {
          if (this.parent.fromAmount != undefined) {
            return val > this.parent.fromAmount;
          } else {
            return true;
          }
        }
      )
      .test(
        "toAmountCannotBeEmpty",
        "US.COLLECTION.VALIDATIONS:REQUIRED.TO_AMOUNT_CANNOT_BE_EMPTY",
        function (val: any) {
          if (this.parent.rangeLength != 0) {
            return val > 0;
          } else {
            return true;
          }
        }
      ),
    calculationType: Yup.string(),
    baseAmount: Yup.number().when("calculationType", {
      is: "RATE",
      then: Yup.number().required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
      ),
      otherwise: Yup.number().notRequired(),
    }),
    feeRate: Yup.number().when("calculationType", {
      is: "RATE",
      then: Yup.number().required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
      ),
      otherwise: Yup.number().notRequired(),
    }),
    reminderFee: Yup.number().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_GIVE_VALID_RECORD"
    ),
  });
};
